import { lazy } from "react";

const BankTransactions = lazy(() => import("./BankTransactions"));
const Reconcile = lazy(() => import("./Reconcile"));
const Rules = lazy(() => import("./Rules"));
const ChartOfAccounts = lazy(() => import("./ChartOfAccounts"));
const RecurringTransactions = lazy(() => import("./RecurringTransactions"));


const TransactionsRoutes = [
  {
    path: "/transactions/bank",
    element: <BankTransactions />,
  },
  {
    path: "/transactions/reconcile",
    element: <Reconcile />,
  },
  {
    path: "/transactions/rules",
    element: <Rules />,
  },
  {
    path: "/transactions/ChartOfAccounts",
    element: <ChartOfAccounts />,
  },
  {
    path: "/transactions/RecurringTransactions",
    element: <RecurringTransactions />,
  },
 
];

export default TransactionsRoutes;
